import { Box } from "@mui/material";
import {
  getInRepairRagDisplayLabel,
  IN_REPAIR_BADGE_BASE_SX,
  IN_REPAIR_STATUS_STYLES,
} from "../data/inRepairListingConstants";

const InRepairStatusBadge = ({ label }) => {
  if (!label) return null;

  const displayLabel = getInRepairRagDisplayLabel(label);
  const style =
    IN_REPAIR_STATUS_STYLES[displayLabel] ||
    IN_REPAIR_STATUS_STYLES[label] || {
      bg: "#888888",
      color: "#ffffff",
    };

  return (
    <Box
      component="span"
      sx={{
        ...IN_REPAIR_BADGE_BASE_SX,
        backgroundColor: style.bg,
        color: style.color,
      }}
    >
      {displayLabel}
    </Box>
  );
};

export default InRepairStatusBadge;
